export default __webpack_public_path__ + "static/media/napaPrivilegeLogo_en.49a0cd25.svg";